export function preloadImages(images: string[]): void {
    images.forEach((image) => {
        new Image().src = image;
    });
}
